/**
 * @file
 * Sitewide javascript behaviors.
 */
(function($) {
    'use strict';

    /* Facet Blocks: toggle collapsible identifiers. */
    $('.block-facets')
        .on('show.bs.collapse', function() {
            $(this)
                .find('span.glyphicon-menu-up')
                .removeClass('glyphicon-menu-up')
                .addClass('glyphicon-menu-down');
        })
        .on('hide.bs.collapse', function() {
            $(this)
                .find('span.glyphicon-menu-down')
                .removeClass('glyphicon-menu-down')
                .addClass('glyphicon-menu-up');
        });

    /* Toggle responsive collapse for facets sidebar. */
    var path_classes = [
        '.path-mqp-opportunities',
        '.path-iqp-opportunities',
        '.path-hua-opportunities'
    ];
    path_classes.forEach(function(path_class) {
        var full_path_class = path_class + ' .region-sidebar-first';
        // Add a button to act as the controlling button for collapse.
        $('<a data-toggle="collapse" data-target="#facet-wrapper" class="facet-sidebar-toggle-button"><span class="glyphicon glyphicon-menu-hamburger"></span> Filter</span></a>')
            .insertBefore(full_path_class);
        // Add wrapper around sidebar so collapse runs smoothly.
        $(full_path_class).wrap('<div class="collapse" id="facet-wrapper"></div>');
    });

    /* Project Centers: toggle collapsible identifiers. */
    $('.collapse').on('show.bs.collapse', function() {
        var i = $(this).parent().find('i.glyphicon-menu-up')
        i.addClass('glyphicon-menu-down');
        i.removeClass('glyphicon-menu-up');
    }).on('hide.bs.collapse', function() {
        var i = $(this).parent().find('i.glyphicon-menu-down')
        i.addClass('glyphicon-menu-up');
        i.removeClass('glyphicon-menu-down');
    });

    /* Hide local Drupal Login form on Login Page. */
    $('#drupal-local-login-form').hide();
    $('#drupal-local-login-form-btn').click(function() {
        $('#drupal-local-login-form').toggleClass('active');
    });

    /* Add Custom option to Contact Address Type Taxonomy Term Select List */
    $('#field-address-values .field--name-field-type select')
        .append($('<optgroup/>'));
    $('#field-address-values .field--name-field-type select optgroup')
        .append($('<option/>', {
            value: '_custom',
            text: 'Custom...',
            class: 'add-custom-term'
        }));

    /* MQP: Show the Continuation Fields if there's a previous project. */
    function setContinuationFieldsState() {
        if ($('#edit-field-continuation-value').is(':checked')) {
            $('#continuation-fields').show();
        } else {
            $('#continuation-fields').hide();
        }
    }
    $('#edit-field-continuation-value').change(setContinuationFieldsState);
    setContinuationFieldsState();

    /* Add custom term to Type Taxonomy Term Select List */
    $('#field-address-values .field--name-field-type select')
        .change(function() {
            if ($(this).val() === '_custom') {
                alert('Not yet implemented: add a custom type right here.');
                // 1. open modal
                // 2. after opening modal, set select list back to _none or (previous value)
                // 3. if modal input is saved/submitted, send ajax request to create Term and get term data back
                // 4. add new Term option to type select list and select that Term
                $(this).val('_none');
            }
        });

    $(function() {
        $('.scrollto').on('click', function() {
            event.preventDefault();

            var defaultAnchorOffset;
            if ($('body').hasClass('toolbar-fixed')) {
                defaultAnchorOffset = 200;
            } else {
                defaultAnchorOffset = 100;
            }

            var anchor = $(this).attr('data-attr-scroll');

            var anchorOffset = $('#' + anchor).attr('data-scroll-offset');
            if (!anchorOffset) {
                anchorOffset = defaultAnchorOffset;
            }

            $('html,body').animate({
                scrollTop: $('#' + anchor).offset().top - anchorOffset
            }, 200);
        });
    });

    /* toggle active class on action buttons (applicant review) */
    $('.actionButtons h2 span').on('click', function() {
        $('.actionButtons').toggleClass('active');
    });

    /* appends current year to award winner select box */
    // var year = (new Date()).getFullYear();
    // $('#edit-field-award-winner option').each(function (i) {
    // if (i > 0) {
    // $(this).append(' (' + year + ')');
    // }
    // console.log($(this).text());
    // });

    /* NOTE: commented out section above still left
      just in case they decide to bring back this functionality. */

    /* Modifies export button for bepress */
    $('.xlsx-feed a').text(function(index, text) {
        return text.replace('Subscribe to', ' EXPORT ');
    });

    /* Make essay field visible, hide upload */
    $('.help-block').on('click', function() {
        $(this).parents('.form-wrapper').css('width', '100%').addClass('show-text-field');
        $(this).parents('.form-wrapper').find('.field--type-file').hide();
    });

    /* Remove field numbers from labels */
    $('#authors-wrapper .tabbed label').text(function(i, txt) {
        return txt.replace(/-?[0-9]*\.?[0-9]+/, '');
    });

    /**
     * Site Term Edit Form:
     * Control visiblity of Group Pick Up Details field based on selection of Group Pick Up Provided field.
     * Conditional fields are not available for Group entities.
     */
    if ($('form.group-site-term-edit-form #edit-field-group-pick-up-provided').length > 0) {
        // Set visibility on page load.
        if ($('#edit-field-group-pick-up-provided').val() != 'Yes') {
            $('#edit-field-group-pick-up-details-wrapper').hide();
        }
        // Toggle visiblity of detail field on change of drop-down.
        $('form.group-site-term-edit-form #edit-field-group-pick-up-provided').change(function() {
            if ($('#edit-field-group-pick-up-provided').val() != 'Yes') {
                $('#edit-field-group-pick-up-details-wrapper').hide();
            } else {
                $('#edit-field-group-pick-up-details-wrapper').show();
            }
        });
    }

    /* Change upload links to to say "view File" on GPS posters view only. */
    $('.view-gps-posters .file-link a').text('View File');

    $('.group.add.project .js-form-submit').on('click', function() {
        $('.required-fields.field-group-tab .panel-body').addClass('in');
    });

    // Temp solution for empty facets showing up.
    $('.facet-empty').parent().hide();

    $('.can-remove td').append("<span class='remove-line'>X</span>");

    $('.remove-line').on('click', function() {
        $(this).parents('tr').remove();
    });

    $('#webform-submission-19-20-iqp-application-edit-all-form .description.help-block .visually-hidden').removeClass('visually-hidden');
    $('#webform-submission-supplemental-iqp-application-19-edit-all-form .description.help-block .visually-hidden').removeClass('visually-hidden');

    var cake = $('.path-group .tabs--primary.nav.nav-tabs').length;

    if (cake > 0) {
        $('.name-status').addClass('hasTabs');
    }


    var incomingfacultyimage = $('.field--name-field-faculty-image-link .field--item').text();
    console.log(incomingfacultyimage);
    // $('.field--name-field-faculty-image-link').append(incomingfacultyimage);

    if (incomingfacultyimage) {
        $('.field--name-user-picture').remove();
        $('.field--name-field-faculty-image-link').append(incomingfacultyimage);
        $('.field--name-field-faculty-image-link .field--item').remove();
        $('.field--name-field-faculty-image-link .field--label').remove();

        console.log('there is an incoming image');
    }

    $('.views-field.views-field-field-faculty-image-link').each(function() {
        var image = $(this).text();
        $(this).append(image);
        $('.views-field.views-field-field-faculty-image-link .field-content').css('display', 'none');
    });

})(jQuery);

(function($, Drupal) {

    'use strict';

    /**
     * Track file uploads and display confirm dialog when an file upload is inprogress.
     *
     * @type {Drupal~behavior}
     */
    Drupal.behaviors.wpiUploadTracker = {
        attach: function attach(context) {
            $(context).find('input[type="file"]').once('wpi-upload-tracker').on('change', function() {
                // Track file upload.
                $(this).data('wpi-track-file-upload', true);

                // Increment form file uploads.
                var $form = $(this.form);
                var fileUploads = ($form.data('wpi-track-file-uploads') || 0);
                $form.data('wpi-track-file-uploads', fileUploads + 1);

                $(this).after('<div class="wpi-track-file-upload-spinner alert alert-info"><span class="glyphicon glyphicon-refresh glyphicon-spinning"></span> Uploading...</div>');

                if (fileUploads === 0) {
                    // Add an upload message next to the submit button.
                    $(this.form).find('.form-actions').before('<div class="alert alert-info" id="wpi-upload-tracker"><span class="glyphicon glyphicon-refresh glyphicon-spinning"></span> Upload in progress... please wait before saving.</div>');
                }

                // Add submit handler to file upload form.
                $(this.form)
                    .once('wpi-upload-tracker')
                    .on('submit', function(event) {
                        var message = Drupal.t('File upload in progress. Uploaded file will be lost.') +
                            '\n' +
                            Drupal.t('Do you want to continue?');
                        if ($form.data('wpi-track-file-uploads') > 0 && !window.confirm(message)) {
                            event.preventDefault();
                        }
                    });
            });
        },
        detach: function detach(context, settings, trigger) {
            if (trigger === 'unload') {
                $(context).find('input[type="file"]').removeOnce('wpi-upload-tracker').each(function() {
                    if ($(this).data('wpi-track-file-upload')) {
                        // Remove file upload tracking.
                        $(this).removeData('wpi-track-file-upload');

                        $(this).remove('.wpi-track-file-upload-spinner');

                        // Decrease form file uploads.
                        var $form = $(this.form);
                        var fileUploads = ($form.data('wpi-track-file-uploads') || 0);
                        $form.data('wpi-track-file-uploads', fileUploads - 1);

                        // Remove the upload message next to the submit button.
                        if (fileUploads - 1 === 0) {
                            // Last one to leave, turn out the lights...
                            $('#wpi-upload-tracker').remove();
                        }
                    }
                });
            }
        }
    };

    /**
     * Show/Hide embargo information for project paragraph fields when embargo checkbox is checked.
     *
     * @type {Drupal~behavior}
     */
    Drupal.behaviors.wpiProjectSubmissionEmbargoToggler = {
        attach: function attach(context) {

            // on load
            $('body').find('.field--name-field-additional-project-files input[type="checkbox"]').once('wpi-embargo-load-toggler').each(function() {
                var checkbox = $(this);
                var container = checkbox.parent().parent().parent().siblings('.wpi_project_submission_embargo_details');
                if (checkbox.is(':checked')) {
                    $(container).show();
                } else {
                    $(container).hide();
                }
            });

            // on change
            $('body').find('.field--name-field-additional-project-files input[type="checkbox"]').once('wpi-embargo-toggler').on('change', function() {
                var checkbox = $(this);
                var container = checkbox.parent().parent().parent().siblings('.wpi_project_submission_embargo_details');
                if (checkbox.is(':checked')) {
                    $(container).show();
                } else {
                    $(container).hide();
                }
            });
        }
    };

    /**
     * Show/Hide embargo information for ETD paragraph fields when embargo checkbox is checked.
     *
     * @type {Drupal~behavior}
     */
    Drupal.behaviors.wpiEmbargoToggler = {
        attach: function attach(context) {

            // on load
            $('body').find('.field--name-field-extra-files input[type="checkbox"]').once('wpi-embargo-load-toggler').each(function() {
                var checkbox = $(this);
                var container = checkbox.parent().parent().parent().siblings('.wpi_etd_submission_embargo_details');
                if (checkbox.is(':checked')) {
                    $(container).show();
                } else {
                    $(container).hide();
                }
            });

            // on change
            $('body').find('.field--name-field-extra-files input[type="checkbox"]').once('wpi-embargo-toggler').on('change', function() {
                var checkbox = $(this);
                var container = checkbox.parent().parent().parent().siblings('.wpi_etd_submission_embargo_details');
                if (checkbox.is(':checked')) {
                    $(container).show();
                } else {
                    $(container).hide();
                }
            });
        }
    };

    /**
     * Show/Hide student or advisor information on member edit screen for Projects.
     *
     * @type {Drupal~behavior}
     */
    Drupal.behaviors.wpiProjectMemberEditToggler = {
        attach: function attach(context) {

            // on load
            $(context).find('.field--name-group-roles select[name="group_roles"]').once('wpi-project-member-load-toggler').each(function() {
                var selectBox = $(this);

                // Hide all fields by default.
                $('.field--name-field-advisor-credit').hide();
                $('.field--name-field-advisor-of-record').hide();
                $('.field--name-field-is-primary-advisor').hide();
                $('.field--name-field-is-submitting-cdr').hide();
                // Access is already denied server-side. Don't hide, so that admins can still edit this.
                //$('.field--name-field-terms-and-units').hide();
                //$('.field--name-field-grade-option').hide();
                //$('.field--name-field-final-grade').hide();
                //$('.field--name-field-capstone-satisfied').hide();

                // Show the ones for this role only.
                if (selectBox.val() === 'project-advisor' || selectBox.val() === 'project-co_advisor') {
                    $('.field--name-field-advisor-credit').show();
                    $('.field--name-field-is-primary-advisor').show();
                    $('.field--name-field-advisor-of-record').show();
                } else if (selectBox.val() === 'project-student') {
                    //$('.field--name-field-is-submitting-cdr').show();
                    //$('.field--name-field-terms-and-units').show();
                    //$('.field--name-field-grade-option').show();
                    //$('.field--name-field-final-grade').show();
                }
            });

            // on change
            $(context).find('.field--name-group-roles select[name="group_roles"]').once('wpi-project-member-toggler').on('change', function() {
                var selectBox = $(this);

                // Hide all fields by default.
                $('.field--name-field-advisor-credit').hide();
                $('.field--name-field-advisor-of-record').hide();
                $('.field--name-field-is-primary-advisor').hide();
                $('.field--name-field-is-submitting-cdr').hide();
                // Access is already denied server-side. Don't hide, so that admins can still edit this.
                //$('.field--name-field-terms-and-units').hide();
                //$('.field--name-field-grade-option').hide();
                //$('.field--name-field-final-grade').hide();

                // Show the ones for this role only.
                if (selectBox.val() === 'project-advisor' || selectBox.val() === 'project-co_advisor') {
                    $('.field--name-field-advisor-credit').show();
                    $('.field--name-field-is-primary-advisor').show();
                    $('.field--name-field-advisor-of-record').show();
                } else if (selectBox.val() === 'project-student') {
                    //$('.field--name-field-is-submitting-cdr').show();
                    //$('.field--name-field-terms-and-units').show();
                    //$('.field--name-field-grade-option').show();
                    //$('.field--name-field-final-grade').show();
                }
            });
        }
    };


})(jQuery, Drupal);